// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchBoxStyles } from "@conklin/Overrides/Widgets/MyLists/MyListsSearchBox";
import IconSearch from "@conklin/XDL/Icons/IconSearch";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

searchBoxStyles.search = {
    mergeCss: true,
    cssOverrides: {
        formInputWrapper: css`
            width: 310px;
            ${xScreen("lte", "md")} {
                width: 100%;
            }
        `,
    },
    iconProps: {
        src: IconSearch,
        color: "common.ui5",
        size: 14,
        mergeCss: true,
        css: css`
            &&& {
                right: 2px;
                padding: 0;
                width: 22px;
            }
        `,
    },
};
